import { defineSlotRecipe } from "@pandacss/dev";

export const aromaEmptyState = defineSlotRecipe({
  className: "aroma-empty-state",
  jsx: ["EmptyState"],
  slots: ["root", "content", "art", "heading", "motivation"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    content: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    art: {
      color: "content.neutral.base.bold",
    },
    heading: {
      color: "content.neutral.base.bold",
    },
    motivation: {
      color: "content.neutral.base.subtle",
      textAlign: "center",
    },
  },
  variants: {
    size: {
      small: {
        root: {
          gap: "gap.4",
          maxWidth: "390px",
        },
        content: {
          gap: "gap.4",
        },
        art: {
          maxWidth: "200px",
          maxHeight: "200px",
        },
        heading: {
          textStyle: "title.s",
        },
        motivation: {
          textStyle: "paragraph.m.regular",
        },
      },
      medium: {
        root: {
          gap: "gap.6",
          width: "480px",
        },
        content: {
          gap: "gap.4",
        },
        art: {
          maxWidth: "280px",
          maxHeight: "280px",
        },
        heading: {
          textStyle: "title.l",
        },
        motivation: {
          textStyle: "paragraph.l.regular",
        },
      },
      large: {
        root: {
          gap: "gap.8",
          width: "560px",
        },
        content: {
          gap: "gap.6",
        },
        art: {
          maxWidth: "400px",
          maxHeight: "400px",
        },
        heading: {
          textStyle: "title.xl",
        },
        motivation: {
          textStyle: "paragraph.l.regular",
        },
      },
    },
    function: {
      Ai: {},
      Guide: {},
      TaskCompleted: {},
      Success: {},
      Error: {},
      Loading: {},
      Information: {},
    },
  },
  defaultVariants: {
    size: "medium",
  },
});
